import { useState } from "react";
import Editor from '@threeskye/editor-component-slate';
import './SlateEditor.scss';

const SlateEditor = (props) => {
	const initial = props.load;
	const [value, setValue] = useState(initial);

	return (
		<>
			<div className="threeskye-editor">
				<Editor
					readOnly={props.readOnly}
					addins={() => props.addins}
					className={`editor-wrapper${props.passedClassName ? " " + props.passedClassName : ""}`}
					value={value || []}
					onChange={(bits) => { props.onChange(bits); setValue(bits); }}
					toolbar={props.toolbar || { type: "full" }}
					setToolbar={props.setToolbar}
					colourOptions={props.colourOptions}
					hideToc={props.hideToc}
					extensions={props.extensions}
					throwToaster={props.throwToaster}
					renderFlowtingInsertMenu={props.renderFlowtingInsertMenu}
					injectedCellStyles={props.injectedCellStyles}
					editorClicked={props.editorClicked}
					insertMenuPosition={props.insertMenuPosition}
					simpleToolBar={props.simpleToolBar}
					allBoundaries={props.allBoundaries}
					injectedStyles={props.injectedStyles}
					customisedToolbarButtons={props.customisedToolbarButtons}
					editableStyle={props.editableStyle}
				/>
			</div>
		</>
	)
}


export default SlateEditor;